import { MAX_QTY } from '../data/projectCard';

const FRACTION_DIGITS = 3;

export const sanitizeQty = (raw: string, allowFraction: boolean): string => {
    const cleaned = raw.replace(/[^\d.,]/g, '');

    if (!allowFraction) return cleaned.replace(/[.,]/g, '');

    const match = cleaned.match(new RegExp(`^(\\d*)([.,]?)(\\d{0,${FRACTION_DIGITS}})`));
    return match ? match[1] + match[2] + match[3] : '';
};

export const parseQty = (text: string): number => {
    const value = Number(text.replace(',', '.')) || 0;
    return Math.min(Math.round(value * 1000) / 1000, MAX_QTY);
};

export const formatQty = (qty: number): string =>
    qty ? String(qty).replace('.', ',') : '';